export const API_preferences_user = (userId: string): string =>
  `/api/v1/preferences/users/${userId}`;
export const API_preferences_users_workspaces = (workspaceId: string): string =>
  `/api/v1/preferences/users/workspaces/${workspaceId}`;
